import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import * as S from '../UserAdsSection/UserAdsSection.styles';
import { UserInfoHeaderSkeleton } from '../UserInfoHeader';
import { DesktopFilters } from '@/components/Filters/DesktopFilters';
import { AdsSection } from '@/components/AdsSection/AdsSection';
import { AdsChunkSize } from '@/components/AdsWithInfiniteScroll/AdsWithInfiniteScroll.types';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

const ChipRow = styled.div`
  display: flex;
  gap: 5px;
`;

const CHIP_WIDTHS = [50, 120, 110, 90];

export const UserAdsSkeleton = () => {
  const { t } = useTranslation();

  return (
    <>
      <UserInfoHeaderSkeleton />
      <S.Section>
        <S.Header>
          <S.Title>{t('pages.ads.user_ads')}</S.Title>
          <S.DesktopSorting>
            <SkeletonLoader width={173} height={40} borderRadius={20} />
          </S.DesktopSorting>
        </S.Header>

        <S.MobileFiltersRow>
          <ChipRow>
            {CHIP_WIDTHS.map((width, index) => (
              <SkeletonLoader
                key={`chip-${index}`}
                width={width}
                height={35}
                borderRadius={18}
              />
            ))}
          </ChipRow>
        </S.MobileFiltersRow>

        <S.Body>
          <S.Sidebar>
            <DesktopFilters isCompact showSellerType={false} />
          </S.Sidebar>

          <S.ListColumn>
            <S.SummaryRow>
              <SkeletonLoader width={90} height={18} borderRadius={6} />
            </S.SummaryRow>
            <AdsSection adsLoading chunkSize={AdsChunkSize.Middle} noPadding />
          </S.ListColumn>
        </S.Body>
      </S.Section>
    </>
  );
};
